import React, {useEffect, useState} from "react";
import {Box} from "@mui/system";
import _ from "lodash";
import {websocket} from "_helpers";
import {componentControl} from "../../../utilities/Component.utils";
import CompanyUpdate from "../../Vote/CompanyUpdate/CompanyUpdate";
import styles from "../MessageDetails/messageDetailsMainStyles";
import useViewVerticalScrollStatus from "../../Vote/Utilities/hooks/useViewVerticalScrollStatus";
import BackToMessages from "./Sections/HeaderSection/BackToMessages";
import MessageDetailsHeaderSection from "./Sections/HeaderSection/MessageDetailsHeaderSection";
import MessageDetailsBodySection from "./Sections/BodySection/MessageDetailsBodySection";
import MessageDetailsFooterSection from "./Sections/FooterSection/MessageDetailsFooterSection";
import useViewMessageDetails from "./Utilities/hooks/useViewMessageDetails";
import {getOrganization} from "./Utilities/MessageDetailsUtils";

export default function MessageDetailsEntry({}) {
    const {isVerticalScrollComplete} = useViewVerticalScrollStatus();
    const [isEnabled, setIsEnabled] = useState(false);
    const { message } = useViewMessageDetails();
    const organization = getOrganization(message);
    const organizationId = _.get(organization, 'id');

    useEffect(() => {
        websocket.connect();
        return () => websocket.disconnect();
    }, []);

    const handleIsEnabled = (value) => {
        setIsEnabled(value);
    }

    let editedResponseObj = {};
    let editedSubjectObj = {};

    return(
        <Box sx={styles.root}>
            <CompanyUpdate handleIsEnabled={handleIsEnabled} organizationId={organizationId}/>
            <BackToMessages />
            <Box sx={{...styles.container, ...componentControl(isEnabled)}}>
                <Box sx={styles.contentArea}>
                    <MessageDetailsHeaderSection organizationId={organizationId} />
                    <MessageDetailsBodySection
                        isScrollComplete={isVerticalScrollComplete}
                        editedResponseObj={editedResponseObj}
                        editedSubjectObj={editedSubjectObj}
                    />
                    <MessageDetailsFooterSection
                        isScrollComplete={isVerticalScrollComplete}
                    />
                </Box>
            </Box>
        </Box>
    )
}